import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Flex,
  Input,
  InputGroup,
  InputLeftElement,
  Text,
  Card,
  CardBody,
  Skeleton,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
} from "@chakra-ui/react";
import { SearchIcon } from "../../assets/svgs/Icons";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getInventoryCertificationList } from "./InventorySlice";
import { unwrapResult } from "@reduxjs/toolkit";
import isAllowed from "../../routing/isAllowed";

function Inventory() {
  const dispatch = useDispatch();
  const { cardList, isloading } = useSelector((state) => state.inventory);
  const [status, setStatus] = useState("idle");
  const { userData } = useSelector((state) => state.auth);
  const [searchValue, setSearchValue] = useState("");
  const [selectedTab, setSelectedTab] = useState("CERTIFIED");

  const handleTabChange = (index) => {
    const tabOptions = ["CERTIFIED", "NON_CERTIFIED", "EXTERNAL_CERTIFIED"];
    setSelectedTab(tabOptions[index]);
  };

  const filteredCards =
    searchValue === ""
      ? cardList
      : cardList?.filter(
          (card) =>
            card?.unitDetails.name?.includes(searchValue) ||
            card?.programDetails.name?.includes(searchValue)
        );

  const getInventoryList = (certificationStatus) => {
    try {
      setStatus("pending");
      dispatch(getInventoryCertificationList(certificationStatus));
      setStatus("success");
    } catch (error) {
      unwrapResult(error);
    }
  };

  useEffect(() => {
    getInventoryList(selectedTab);
  }, [selectedTab]);

  return (
    <Box paddingTop={"3rem"}>
      <Flex gap={"10"} alignItems={"center"} justifyContent={"space-between"}>
        <Box>
          <Text color="brand.blue" fontSize="2xl" fontWeight={"800"}>
            Inventory
          </Text>
          <Text color="brand.royalBlue" fontSize="sm">
            List of all inventory items
          </Text>
        </Box>
        <Box>
          <Flex justifyContent={"space-around"}>
            <Box margin={"10px"}>
              <InputGroup>
                <InputLeftElement
                  pointerEvents="none"
                  children={<SearchIcon color={"brand.lightBlue"} />}
                />
                <Input
                  type="tel"
                  color={"brand.black"}
                  bg={"brand.white"}
                  placeholder="Search"
                  fontSize={"14px"}
                  fontWeight={"300"}
                  borderRadius={"10px"}
                  onChange={(e) => setSearchValue(e.target.value)}
                />
              </InputGroup>
            </Box>
            <Box margin={"10px"}>
              {userData?.role?.includes("NONGINNER") ? (
                <></>
              ) : (
                <Button
                  color="brand.white"
                  bg="brand.secondaryColor"
                  colorScheme="brand.secondaryColor"
                >
                  <Link to={`/procurement/procurement-form`}>
                    Add Procurement
                  </Link>
                </Button>
              )}
            </Box>
          </Flex>
        </Box>
      </Flex>
      <Tabs variant="enclosed" mt="2rem" onChange={handleTabChange}>
        <TabList>
          <Tab
            _selected={{
              bg: "white",
              fontWeight: 500,
            }}
          >
            Certified
          </Tab>
          <Tab
            _selected={{
              bg: "white",
              fontWeight: 500,
            }}
          >
            Non-Certified
          </Tab>
          <Tab
            _selected={{
              bg: "white",
              fontWeight: 500,
            }}
          >
            Third Party Certified
          </Tab>
        </TabList>
        <TabPanels>
          <TabPanel bg="white">
            <Box size="lg" bg="brand.white" borderRadius="15px" margin="24px">
              {isloading ? (
                <Flex
                  gap="10"
                  alignContent={"center"}
                  flexDirection={"row"}
                  flexWrap="wrap"
                >
                  <Skeleton
                    w="270px"
                    h="200px"
                    borderRadius="8px"
                    fadeDuration={1}
                  />
                  <Skeleton
                    w="270px"
                    h="200px"
                    borderRadius="8px"
                    fadeDuration={1}
                  />
                  <Skeleton
                    w="270px"
                    h="200px"
                    borderRadius="8px"
                    fadeDuration={1}
                  />
                  <Skeleton
                    w="270px"
                    h="200px"
                    borderRadius="8px"
                    fadeDuration={1}
                  />
                  <Skeleton
                    w="270px"
                    h="200px"
                    borderRadius="8px"
                    fadeDuration={1}
                  />
                </Flex>
              ) : filteredCards?.length > 0 ? (
                <Flex
                  gap="10"
                  alignContent={"center"}
                  flexDirection={"row"}
                  flexWrap="wrap"
                >
                  {filteredCards?.map((card) => (
                    <Card
                      key={card.id}
                      w="270px"
                      h="200px"
                      bg="brand.white"
                      overflow="hidden"
                      borderRadius="8px"
                      boxShadow={"rgba(100, 100, 111, 0.2) 0px 10px 26px 0px"}
                    >
                      <CardBody>
                        <Flex
                          flex="1"
                          gap="2"
                          flexWrap="wrap"
                          flexDirection={"column"}
                          color="brand.black"
                        >
                          <Text
                            fontSize={"18px"}
                            fontWeight="500"
                            fontStyle={"normal"}
                            lineHeight={"21px"}
                          >
                            {card?.programDetails?.name}
                          </Text>

                          <Box
                            fontSize={"14px"}
                            fontWeight="400"
                            fontStyle={"normal"}
                            lineHeight="14px"
                            display="flex"
                          >
                            <Text>Unit:&nbsp;</Text>
                            <Text>{`${card?.unitDetails?.name}`}</Text>
                          </Box>
                          {card?.heapId && (
                            <Box
                              display="flex"
                              fontSize={"14px"}
                              fontWeight="400"
                              fontStyle={"normal"}
                              lineHeight="14px"
                            >
                              <Text>Heap:&nbsp;</Text>
                              <Text>{`${card?.heapDetails?.number}`}</Text>
                            </Box>
                          )}

                          <Box marginTop={"22px"}>
                            <Flex justifyContent={"space-between"}>
                              <Box>
                                <Text
                                  fontSize={"12px"}
                                  fontWeight="400"
                                  fontStyle={"normal"}
                                  lineHeight="14px"
                                >
                                  Total Inventory Available
                                </Text>
                                <Text
                                  fontSize={"14px"}
                                  fontWeight="800"
                                  fontStyle={"normal"}
                                  lineHeight="16px"
                                  color="brand.blue"
                                >
                                  {`${card?.availableStock.toFixed(2)} kg`}
                                </Text>
                              </Box>
                              <Box>
                                <Button
                                  w={"97px"}
                                  h={"34px"}
                                  color="brand.white"
                                  bg="brand.secondaryColor"
                                  colorScheme="brand.secondaryColor"
                                  borderRadius={"6px"}
                                  shadow="none"
                                  onClick={() =>
                                    localStorage.setItem(
                                      "heapId",
                                      card?.heapDetails?._id
                                    )
                                  }
                                >
                                  <Link
                                    to={`./inventory-list/${card?.unitId}/${card?.programId}`}
                                  >
                                    View List
                                  </Link>
                                </Button>
                              </Box>
                            </Flex>
                          </Box>
                        </Flex>
                      </CardBody>
                    </Card>
                  ))}
                </Flex>
              ) : (
                // Display different message when no inventory is available
                <Box
                  display={"flex"}
                  alignItems="center"
                  justifyContent="center"
                >
                  <Text
                    fontSize={"25px"}
                    fontWeight={"bold"}
                    textAlign="center"
                  >
                    {searchValue
                      ? "No inventory matches were found for the entered keyword."
                      : "No inventory available."}
                  </Text>
                </Box>
              )}
            </Box>
          </TabPanel>
          <TabPanel bg="white">
            <Box size="lg" bg="brand.white" borderRadius="15px" margin="24px">
              {isloading ? (
                <Flex
                  gap="10"
                  alignContent={"center"}
                  flexDirection={"row"}
                  flexWrap="wrap"
                >
                  <Skeleton
                    w="270px"
                    h="200px"
                    borderRadius="8px"
                    fadeDuration={1}
                  />
                  <Skeleton
                    w="270px"
                    h="200px"
                    borderRadius="8px"
                    fadeDuration={1}
                  />
                  <Skeleton
                    w="270px"
                    h="200px"
                    borderRadius="8px"
                    fadeDuration={1}
                  />
                  <Skeleton
                    w="270px"
                    h="200px"
                    borderRadius="8px"
                    fadeDuration={1}
                  />
                  <Skeleton
                    w="270px"
                    h="200px"
                    borderRadius="8px"
                    fadeDuration={1}
                  />
                </Flex>
              ) : filteredCards?.length > 0 ? (
                <Flex
                  gap="10"
                  alignContent={"center"}
                  flexDirection={"row"}
                  flexWrap="wrap"
                >
                  {filteredCards?.map((card) => (
                    <Card
                      key={card.id}
                      w="270px"
                      h="200px"
                      bg="brand.white"
                      overflow="hidden"
                      borderRadius="8px"
                      boxShadow={"rgba(100, 100, 111, 0.2) 0px 10px 26px 0px"}
                    >
                      <CardBody>
                        <Flex
                          flex="1"
                          gap="2"
                          flexWrap="wrap"
                          flexDirection={"column"}
                          color="brand.black"
                        >
                          <Text
                            fontSize={"18px"}
                            fontWeight="500"
                            fontStyle={"normal"}
                            lineHeight={"21px"}
                          >
                            {card?.programDetails?.name}
                          </Text>

                          <Box
                            fontSize={"14px"}
                            fontWeight="400"
                            fontStyle={"normal"}
                            lineHeight="14px"
                          >
                            <Text>Unit</Text>
                            <Text>{`${card?.unitDetails?.name}`}</Text>
                          </Box>

                          <Box marginTop={"22px"}>
                            <Flex justifyContent={"space-between"}>
                              <Box>
                                <Text
                                  fontSize={"12px"}
                                  fontWeight="400"
                                  fontStyle={"normal"}
                                  lineHeight="14px"
                                >
                                  Total Inventory Available
                                </Text>
                                <Text
                                  fontSize={"14px"}
                                  fontWeight="800"
                                  fontStyle={"normal"}
                                  lineHeight="16px"
                                  color="brand.blue"
                                >
                                  {`${card?.availableStock.toFixed(2)} kg`}
                                </Text>
                              </Box>
                              <Box>
                                <Button
                                  w={"97px"}
                                  h={"34px"}
                                  color="brand.white"
                                  bg="brand.secondaryColor"
                                  colorScheme="brand.secondaryColor"
                                  borderRadius={"6px"}
                                  shadow="none"
                                >
                                  <Link
                                    to={`./inventory-list/${card?.unitId}/${card?.programId}`}
                                  >
                                    View List
                                  </Link>
                                </Button>
                              </Box>
                            </Flex>
                          </Box>
                        </Flex>
                      </CardBody>
                    </Card>
                  ))}
                </Flex>
              ) : (
                <Box
                  display={"flex"}
                  alignItems="center"
                  justifyContent="center"
                >
                  <Text
                    fontSize={"25px"}
                    fontWeight={"bold"}
                    textAlign="center"
                  >
                    {searchValue
                      ? "No inventory matches were found for the entered keyword."
                      : "No inventory available."}
                  </Text>
                </Box>
              )}
            </Box>
          </TabPanel>
          <TabPanel bg="white">
            <Box size="lg" bg="brand.white" borderRadius="15px" margin="24px">
              {isloading ? (
                <Flex
                  gap="10"
                  alignContent={"center"}
                  flexDirection={"row"}
                  flexWrap="wrap"
                >
                  <Skeleton
                    w="270px"
                    h="200px"
                    borderRadius="8px"
                    fadeDuration={1}
                  />
                  <Skeleton
                    w="270px"
                    h="200px"
                    borderRadius="8px"
                    fadeDuration={1}
                  />
                  <Skeleton
                    w="270px"
                    h="200px"
                    borderRadius="8px"
                    fadeDuration={1}
                  />
                  <Skeleton
                    w="270px"
                    h="200px"
                    borderRadius="8px"
                    fadeDuration={1}
                  />
                  <Skeleton
                    w="270px"
                    h="200px"
                    borderRadius="8px"
                    fadeDuration={1}
                  />
                </Flex>
              ) : filteredCards?.length > 0 ? (
                <Flex
                  gap="10"
                  alignContent={"center"}
                  flexDirection={"row"}
                  flexWrap="wrap"
                >
                  {filteredCards?.map((card) => (
                    <Card
                      key={card.id}
                      w="270px"
                      h="200px"
                      bg="brand.white"
                      overflow="hidden"
                      borderRadius="8px"
                      boxShadow={"rgba(100, 100, 111, 0.2) 0px 10px 26px 0px"}
                    >
                      <CardBody>
                        <Flex
                          flex="1"
                          gap="2"
                          flexWrap="wrap"
                          flexDirection={"column"}
                          color="brand.black"
                        >
                          <Text
                            fontSize={"18px"}
                            fontWeight="500"
                            fontStyle={"normal"}
                            lineHeight={"21px"}
                          >
                            {card?.programDetails?.name}
                          </Text>

                          <Box
                            fontSize={"14px"}
                            fontWeight="400"
                            fontStyle={"normal"}
                            lineHeight="14px"
                          >
                            <Text>Unit</Text>
                            <Text>{`${card?.unitDetails?.name}`}</Text>
                          </Box>

                          <Box marginTop={"22px"}>
                            <Flex justifyContent={"space-between"}>
                              <Box>
                                <Text
                                  fontSize={"12px"}
                                  fontWeight="400"
                                  fontStyle={"normal"}
                                  lineHeight="14px"
                                >
                                  Total Inventory Available
                                </Text>
                                <Text
                                  fontSize={"14px"}
                                  fontWeight="800"
                                  fontStyle={"normal"}
                                  lineHeight="16px"
                                  color="brand.blue"
                                >
                                  {`${card?.availableStock.toFixed(2)} kg`}
                                </Text>
                              </Box>
                              <Box>
                                <Button
                                  w={"97px"}
                                  h={"34px"}
                                  color="brand.white"
                                  bg="brand.secondaryColor"
                                  colorScheme="brand.secondaryColor"
                                  borderRadius={"6px"}
                                  shadow="none"
                                >
                                  <Link
                                    to={`./inventory-list/${card?.unitId}/${card?.programId}`}
                                  >
                                    View List
                                  </Link>
                                </Button>
                              </Box>
                            </Flex>
                          </Box>
                        </Flex>
                      </CardBody>
                    </Card>
                  ))}
                </Flex>
              ) : (
                <Box
                  display={"flex"}
                  alignItems="center"
                  justifyContent="center"
                >
                  <Text
                    fontSize={"25px"}
                    fontWeight={"bold"}
                    textAlign="center"
                  >
                    {searchValue
                      ? "No inventory matches were found for the entered keyword."
                      : "No inventory available."}
                  </Text>
                </Box>
              )}
            </Box>
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
}

export default isAllowed(Inventory);
